<template>
    <!-- BEGIN: Content-->
    <div class="roleList">
      <v-container fluid>

        <v-row>
          <v-col md="12" sm="12" class="d-flex" style="justify-content:space-between">
            <v-breadcrumbs
              :items="breadcrumbs"
              divider="/"
            ></v-breadcrumbs>

            <v-btn
              color="#000000"
              class="white--text"
              depressed
              @click.stop="dialog = true"
            >
              Role
              <v-icon
                right
                dark
              >
                mdi-plus
              </v-icon>
            </v-btn>

          </v-col>
        </v-row>

        <v-row>
          <v-col md="12" sm="12">
            <v-card class="card-shadow py-3">
              <v-data-table
                dense
                :headers="fields"
                :items="roles"
                class="elevation-0"
                loading="false"
                loading-text="Loading... Please wait"
              >
                <template v-slot:item.#="{ item }">
                  {{ item.created_at }}
                </template>
                <template v-slot:item.name="{ item }">
                  {{ item.name }}
                </template>
                <template v-slot:item.action="{ item }">
                  <v-icon
                    small
                    class="mr-2"
                    @click="editType(item.id)"
                  >
                    mdi-pencil
                  </v-icon>
                  <v-icon
                    small
                    @click="deleteItem(item.id)"
                  >
                    mdi-delete
                  </v-icon>
                </template>
              </v-data-table>
            </v-card>
          </v-col>
        </v-row>
      </v-container>


      <!-- add user dialog -->
      <v-dialog
        v-model="dialog"
        max-width="600px"
      >
        <v-card>

          <v-form  enctype="multipart/form-data" v-model="valid" ref="form">

          <v-card-title>
            <span class="text-h6">Add Role</span>
          </v-card-title>

          <v-card-text>
              <v-container>
                <v-row>
                  <v-col
                    cols="12"
                  >
                    <v-text-field
                      label="Role*"
                      v-model="item.role"
                      required
                      :rules="fieldRules"
                    ></v-text-field>
                  </v-col>
                  <v-col
                    cols="12"
                  >
                    <v-row>
                      <v-col cols="12 mb-2">
                        <span style="font-size: .94rem !important;">Permissions*</span>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col col="12" sm="6" md="4" lg="4" class="perm" v-for="(permission, index) in permissions" :key="index">
                        <v-checkbox
                        v-model="item.permission" 
                        :id="permission.text" 
                        :value="permission.value"
                        :label="permission.text"
                        ></v-checkbox>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-container>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
              <v-btn
                color="blue darken-1"
                text
                @click="dialog = false"
              >
                Close
              </v-btn>
              <v-btn
                color="blue darken-1"
                text
                :loading="loading"
                :disabled="!valid"
                @click="create"
              >
                Save
              </v-btn>
          </v-card-actions>

        </v-form>
        </v-card>
      </v-dialog>
      <!-- end user -->

      <!-- user update modal-->
      <v-dialog
        v-model="updatedialog"
        max-width="600px"
      >
        <v-card>

          <v-form  enctype="multipart/form-data" v-model="valid" ref="form">

          <v-card-title>
            <span class="text-h6">Update Role</span>
          </v-card-title>

          <v-card-text>
              <v-container>
                <v-row>
                  <v-col
                    cols="12"
                  >
                    <v-text-field
                      label="Role*"
                      v-model="item.updaterole"
                      required
                      :rules="fieldRules"
                    ></v-text-field>
                  </v-col>
                  <v-col
                    cols="12"
                  >
                    <v-row>
                      <v-col cols="12 mb-2">
                        <span style="font-size: .94rem !important;">Permissions*</span>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col col="12" sm="6" md="4" lg="4" class="perm" v-for="(permission, index) in permissions" :key="index">
                        <v-checkbox
                        v-model="item.updatepermission" 
                        :id="permission.text" 
                        :value="permission.value"
                        :label="permission.text"
                        ></v-checkbox>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-container>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
              <v-btn
                color="blue darken-1"
                text
                @click="updatedialog = false"
              >
                Close
              </v-btn>
              <v-btn
                color="blue darken-1"
                text
                :loading="loading"
                :disabled="!valid"
                @click="update"
              >
                Save
              </v-btn>
          </v-card-actions>

        </v-form>
        </v-card>
      </v-dialog>
      <!-- update user -->

    </div>

</template>
<style scope>
  .custom-control-input{
        width: 1.285rem;
    height: 1.285rem;
    margin-top: .0825rem;
    vertical-align: top;
    background-color: #FFF;
    background-repeat: no-repeat;
    background-position: center;
    background-size: contain;
    border: 1px solid #D8D6DE;
    appearance: none;
    -webkit-print-color-adjust: exact;
    color-adjust: exact;
  }
</style>
<script>
import axios from 'axios'
import { Modal } from 'bootstrap'
import {ability} from '../../services/ability'

export default {
    name:"roleList",
    data(){
        return {
          fieldRules: [
          (v) => !!v || 'Field is required'
          ],
          search:null,
          valid: true,
          searchrole:null,
          dialog: false,
          updatedialog: false,
          breadcrumbs: [
            {
              text: 'Dashboard',
              disabled: false,
              href: '/',
            },
            {
              text: 'User Config',
              disabled: false,
              href: '',
            },
            {
              text: 'Roles',
              disabled: false,
              href: '',
            },
          ],
          fields: [
             {
              text: '#',
              align: 'start',
              value: 'created_at',
            },
            { text: 'Name', value: 'name' },
            { text: 'Action', value: 'action' },
           ],
          item:{
                role:"",
                permission: [],
                updatepermission: [],
                updaterole: "",
                updateID: "",
                _method:"patch"
            },
            loading: false,
           disabled: false,
           roles: [],
           permissions: [],
           isBusy: false,
            updateModal: null
        }
    },
    beforeMount() {
      if(!ability.can('user-management', 'all')) {
        this.$router.push({ name: 'Pos' })
        return
      }
    },
    mounted(){
      this.getRole()
    },
    methods:{
      async getRole(){
        this.isBusy = true
        await axios.get('/roles').then(response=>{
            this.isBusy = false
            this.roles = response.data.roles
            this.permissions = response.data.permissions
        }).catch(error=>{
            console.log(error)
            this.isBusy = false
            this.roles = []
        })
      },
       async create(){

        if (this.$refs.form.validate()) {

          this.loading = true
          this.disabled = true

          const config = { headers: { 'Content-Type': 'multipart/form-data' } };
          let fd = new FormData();
          fd.append('role',this.item.role)
          fd.append('permission',JSON.stringify(this.item.permission))

          await axios.post('/roles', fd, config).then(response=>{
            this.loading = false
            this.disabled = false
            this.res = response.data.status
            if(this.res === parseInt(200))
              this.$toast.success(response.data.message,'Success',{position: 'topRight',timeout: 7000,})
              this.getRole()
              this.clear()
            this.item.role = ''
            this.item.permission = ''
          }).catch(error=>{
            this.loading = false
            this.disabled = false
              console.log(error)
          })

        }

        },
        clear () {
          this.$refs.form.reset()
        },
        async update(){

          if (this.$refs.form.validate()) {

          this.loading = true
          this.disabled = true

            const config = { headers: { 'Content-Type': 'multipart/form-data' } };
            let fd = new FormData();
            fd.append('role',this.item.updaterole)
            fd.append('permission',JSON.stringify(this.item.updatepermission))
            fd.append('_method',this.item._method)

            await axios.post(`/roles/${this.item.updateID}`, fd, config).then(response=>{
              this.loading = false
              this.disabled = false
              this.res = response.data.status
              if(this.res === parseInt(200))
                this.$toast.success(response.data.message,'Success',{position: 'topRight',timeout: 7000,})
                this.updatedialog = false
                this.getRole()
              this.item.updaterole = ''
              this.item.updatepermission = ''
              this.item.updateID = ''
            }).catch(error=>{
              this.loading = false
              this.disabled = false
                console.log(error)
            })

          }

        },
      async editType(id) {
        let index = this.roles.filter(item => item.id === id );

        await axios.get(`/roles/${index[0].id}`).then(response=>{

          this.item.updatepermission = response.data.rolePermissions

          this.item.updaterole = index[0].name
          this.item.updateID = index[0].id
          this.updatedialog = true
          
        }).catch(error=>{
          this.loading = false
          this.disabled = false
            console.log(error)
        })

      },
      deleteItem(id){
            if(confirm("Are you sure to delete role ?")){
                axios.delete(`/roles/${id}`).then(response=>{
                  this.$toast.success(response.data.message,'Success',{position: 'topRight',timeout: 7000,})
                    this.getRole()
                }).catch(error=>{
                    console.log(error)
                })
            }
        }

    }
}
</script>